import React, { useEffect, useState } from 'react';
import { MOBILE_BREAKPOINT } from '../../Utils/responsive';
import GivingAccountApplyWeb from './web';
import GivingAccountApplyMob from './mob';

/** 기부계좌 신청 (/giving-account/apply) */
const GivingAccountApply = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_BREAKPOINT);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile ? <GivingAccountApplyMob /> : <GivingAccountApplyWeb />;
};

export default GivingAccountApply;
